'use client';
import React, { FC, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import style from './ContentHeading.module.scss';
import Image from 'next/image';
import { CompanyLabel } from '@/components/client/CompanyLabel/CompanyLabel';

interface IProps {
  title: string;
  description: string;
  image: string;
}

export const ContentHeading: FC<IProps> = ({ title, description, image }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true }); // Анимация сработает только один раз

  return (
    <div ref={ref}>
      <motion.h2
        className="mb-6 text-left text-4xl font-semibold"
        initial={{ opacity: 0, y: 20 }} // Начальные параметры анимации
        animate={isInView ? { opacity: 1, y: 0 } : {}} // Анимация при появлении
        transition={{ duration: 0.5 }} // Длительность анимации
      >
        {title}
      </motion.h2>
      {!!description && (
        <motion.div
          className={`description-with-links mb-20 whitespace-pre-wrap border-l-2 pl-6 text-left`}
          initial={{ opacity: 0, y: 20 }} // Начальные параметры анимации
          animate={isInView ? { opacity: 1, y: 0 } : {}} // Анимация при появлении
          transition={{ duration: 0.5, delay: 0.2 }} // Задержка анимации для описания
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      <div className={style.imageWrapper}>
        <div className={style.imageWrapperInner}>
          <Image src={image} alt={title} />
          <div className={style.labelWrapper}>
            <CompanyLabel />
          </div>
        </div>
      </div>
    </div>
  );
};
